/**
 * @author: dwi.setiyadi@gmail.com
*/

import storage from 'redux-persist/lib/storage';
// import createEncryptor from 'redux-persist-transform-encrypt';
import { createBlacklistFilter } from 'redux-persist-transform-filter';

// const encryptor = createEncryptor({
//   secretKey: 'abang-baso-jangan-kasih-tau-sipa-siapa-ya',
//   onError(error) {
//     console.log('createEncryptor error ', error); // eslint-disable-line
//   },
// });

const saveAuthSubsetBlacklistFilter = createBlacklistFilter(
  'auth',
  ['data', 
  // 'res', 
  'action'],
);

const blacklistLoader = createBlacklistFilter(
  'loader',
  ['isLoading', 'count']
)

const REDUX_PERSIST = {
  active: true,
  reducerVersion: '1.0',
  storeConfig: {
    key: 'root',
    storage,
    blacklist: ['loader', 'session'],
    // whitelist: ['auth', 'notification'],
    // transforms: [saveAuthSubsetBlacklistFilter, blacklistLoader, encryptor],
    transforms: [saveAuthSubsetBlacklistFilter, blacklistLoader],
  },
};

export default REDUX_PERSIST;
